import z from "zod";

import { zBuildingTypeSchema } from "./building-type";
import { zFloorSchema } from "./floor";
import { zFloorAreaSchema } from "./floor-area";
import { zNumberOfRoomsSchema } from "./number-of-rooms";

const zFromToSchema = z.object({
  city: z
    .string()
    .trim()
    .nonempty()
    .max(2 ** 6),
  address: z
    .string()
    .trim()
    .nonempty()
    .max(2 ** 7),
  floor: zFloorSchema,
  postalCode: z
    .string()
    .trim()
    .nonempty()
    .max(2 ** 4),
  buildingType: zBuildingTypeSchema,
  floorArea: zFloorAreaSchema,
  numberOfRooms: zNumberOfRoomsSchema,
  hasElevator: z.boolean(),
  hasAttic: z.boolean(),
  hasBasement: z.boolean(),
});
type FromToSchema = z.infer<typeof zFromToSchema>;

export { zFromToSchema };
export type { FromToSchema };
